import { FaqProps } from "modules/faq/state/actionType";


interface PreviewFAQProps {
    faqData:FaqProps;
   closeModal: React.Dispatch<React.SetStateAction<boolean>>;
}
const PreviewFAQ:React.FC<PreviewFAQProps> = ({faqData,closeModal}) => {
    return(
        <>
        {
            faqData &&
            <div className="p-4">
                <h2 className="text-xl font-bold mb-4">FAQ Preview</h2>
                <div className="mb-4 text-lg whitespace-pre-line">
                    <h3 className="font-semibold ">Question:</h3>
                    <p>{faqData.question}</p>
                </div>
                <div className="mb-4 text-lg whitespace-pre-line">
                    <h3 className="font-semibold">Answer:</h3>
                    <p className="whitespace-pre-wrap">{faqData.answer}</p>
                </div>
                <div className="flex justify-end">
                    <button
                        onClick={() => closeModal(false)}
                        className="px-4 py-2 bg-primary-500 text-white rounded hover:bg-primary-900"
                    >
                        Close
                    </button>
                </div>
            </div>
        }
        </>
    )
};
export default PreviewFAQ;